import { render } from "./BetterLeaderCharacteristics.vue?vue&type=template&id=757bda16"
import script from "./BetterLeaderCharacteristics.vue?vue&type=script&lang=js"
export * from "./BetterLeaderCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script